import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';

const ExportPage: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const token = localStorage.getItem('token');

  const download = async (path: string, filename?: string) => {
    const res = await fetch(`${API_BASE_URL}${path}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    // Use an explicit filename; otherwise strip any query string so a path like
    // /export/pens.csv?status=active doesn't become a "pens.csv?status=active" file.
    a.download = filename || path.split('?')[0].split('/').pop() || 'export.csv';
    a.click();
    window.URL.revokeObjectURL(url);
  };

  return (
    <div className="container mx-auto px-4 py-6">
      <h1 className="text-2xl font-bold text-emerald-700 mb-4">Export Data</h1>
      {!isAuthenticated && (
        <div className="text-red-600">Please log in to export your data.</div>
      )}
      <div className="grid gap-4 md:grid-cols-3">
        <div className="p-4 border rounded-xl bg-white shadow-sm">
          <h2 className="font-semibold mb-2">Pens</h2>
          <p className="text-sm text-stone-600 mb-3">CSV includes status, first injection date, expiry, cost, clicks and pharmacy for every pen (active, empty, expired and retired).</p>
          <div className="flex flex-wrap gap-2">
            <button onClick={() => download('/export/pens.csv', 'pens.csv')} className="bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-2 rounded-lg">All pens</button>
            <button onClick={() => download('/export/pens.csv?status=active', 'pens-active.csv')} className="bg-white border border-emerald-600 text-emerald-700 hover:bg-emerald-50 px-4 py-2 rounded-lg">Active only</button>
          </div>
        </div>
        <div className="p-4 border rounded-xl bg-white shadow-sm">
          <h2 className="font-semibold mb-2">Dose History</h2>
          <p className="text-sm text-stone-600 mb-3">CSV includes date, pen, strength, pen status, clicks/volume, dose, injection location, pain level.</p>
          <button onClick={() => download('/export/doses.csv')} className="bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-2 rounded-lg">Download</button>
        </div>
        <div className="p-4 border rounded-xl bg-white shadow-sm">
          <h2 className="font-semibold mb-2">Weights</h2>
          <p className="text-sm text-stone-600 mb-3">CSV includes date, weight (kg), source, note.</p>
          <button onClick={() => download('/export/weights.csv')} className="bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-2 rounded-lg">Download</button>
        </div>
        <div className="p-4 border rounded-xl bg-white shadow-sm">
          <h2 className="font-semibold mb-2">Symptoms</h2>
          <p className="text-sm text-stone-600 mb-3">CSV includes date, category, severity, note.</p>
          <button onClick={() => download('/export/symptoms.csv')} className="bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-2 rounded-lg">Download</button>
        </div>
      </div>
    </div>
  );
};

export default ExportPage;


